import { Modal } from "antd";
import FormCotacao from "./FormCotacao";
import { useForm } from "react-hook-form";
import { OrcamentoCotacaoItemForm } from "features/orcamento/typings";
import { useEffect, useState } from "react";
import OutlineButton from "components/Button/OutlineButton";
import PrimaryButton from "components/Button/PrimaryButton";
import { Flex } from "@chakra-ui/react";
import useSaveOrcamentoCotacao from "core/features/orcamento/hooks/useSaveOrcamentoCotacao";
import { showSuccess } from "infra/helpers/alerta";
import { showErrorAxios } from "infra/helpers/alerta";
import { useDetalhesItemCotacao } from "core/features/orcamento/hooks/useDetalhesItemCotacao";
import { useLoading } from "components/GlobalLoading/index";

interface ModalCotacaoProps {
  isOpenModal: boolean;
  onClose: () => any;
  orcamentoId?: string;
  cotacaoId?: string;
  refetchCotacao: any;
}

function ModalCotacao({
  isOpenModal,
  onClose,
  orcamentoId,
  cotacaoId,
  refetchCotacao,
}: ModalCotacaoProps) {
  const defaultValues: OrcamentoCotacaoItemForm = {
    nomeFornecedor: "",
    contato: "",
    dataCotacao: "",
    email: "",
    formaPagamentoId: undefined,
    prazoEntregaDias: undefined,
    dataValidade: "",
    anexos: [],
    orcamentoCotacaoItems: [],
    valorTipo: "individual",
    valorTotal: undefined,
    arquivosExcluidos: [],
  };

  const [arquivosExcluidos, setArquivosExcluidos] = useState<string[]>([]);

  const { mutate: handleSave, isLoading: isLoadingSave } =
    useSaveOrcamentoCotacao(orcamentoId, cotacaoId);

  const { data, isLoading } = useDetalhesItemCotacao(orcamentoId, cotacaoId);

  const { control, reset, handleSubmit, watch, setValue } =
    useForm<OrcamentoCotacaoItemForm>({ defaultValues });
  const form = watch();

  const onSubmit = async (data: OrcamentoCotacaoItemForm) => {
    handleSave(
      { ...data, arquivosExcluidos },
      {
        onSuccess: () => {
          showSuccess().then(() => {
            refetchCotacao();
            onClose();
          });
        },
        onError: (e) => {
          showErrorAxios(e);
        },
      }
    );
  };

  useEffect(() => {
    if (data) {
      reset({
        id: data.id,
        formaPagamentoId: data.formaPagamentoId,
        contato: data.contato,
        dataCotacao: data.dataCotacao,
        dataValidade: data.dataValidade,
        nomeFornecedor: data.nomeFornecedor,
        prazoEntregaDias: data.prazoEntregaDias,
        email: data.email,
        observacao: data.observacao,
        orcamentoCotacaoItems:
          data.orcamentoCotacaoItems?.map((item) => ({
            id: item.id,
            orcamentoItemId: item.orcamentoItemId,
            quantidade: item.quantidade,
            unidadeMedidaId: item.unidadeMedidaId,
            valorUnitario: item.valorUnitario,
            indisponivel: item.indisponivel,
          })) ?? [],
        valorTipo: !!data.valorTotal ? "total" : "individual",
        anexos: data.anexos,
        valorTotal: data.valorTotal,
      });
    }
  }, [data, reset]);

  useLoading(isLoading);

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Modal
        title="Dados da cotação"
        centered
        visible={isOpenModal}
        footer={
          <Flex mt="16px" gap={4} justifyContent={"flex-end"}>
            <OutlineButton onClick={onClose}>Voltar</OutlineButton>
            <PrimaryButton
              onClick={handleSubmit(onSubmit)}
              isLoading={isLoadingSave}
            >
              Salvar
            </PrimaryButton>
          </Flex>
        }
        onCancel={onClose}
        destroyOnClose
        width="1200px"
      >
        <FormCotacao
          orcamentoId={orcamentoId}
          control={control}
          form={form}
          setValue={setValue}
          setArquivosExcluidos={setArquivosExcluidos}
        />
      </Modal>
    </form>
  );
}

export default ModalCotacao;
